/**
 * SuperAdmin Guard — protege rutas /superadmin/*
 * Si no hay token → redirige a /superadmin/login
 */
import { Navigate } from "react-router-dom";
import { getSAToken } from "@/services/superadminApi";

export default function SuperAdminGuard({ children }) {
    const token = getSAToken();
    if (!token) {
        return <Navigate to="/superadmin/login" replace />;
    }
    return children;
}
